"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/http");
var url_1 = require("./url");
var Observable_1 = require("rxjs/Observable");
var authentication_service_1 = require("../shared/service/authentication.service");
var Subject_1 = require("rxjs/Subject");
var HttpRequestBuilder = /** @class */ (function () {
    function HttpRequestBuilder(_http, authenticationService) {
        this._http = _http;
        this.authenticationService = authenticationService;
        this.isLoadingSubject = new Subject_1.Subject();
        this.isLoading$ = this.isLoadingSubject.asObservable();
    }
    HttpRequestBuilder.prototype.post = function (url, data) {
        var _this = this;
        this.isLoadingSubject.next(true);
        return this._http.post("" + url_1.Urls.getBaseUrlApi() + url, data, this.getRequestOptions())
            .map(function (response) { return response; })
            .catch(function (error) { return Observable_1.Observable.throw(error); })
            .finally(function () { return _this.isLoadingSubject.next(false); });
    };
    HttpRequestBuilder.prototype.get = function (url) {
        var _this = this;
        this.isLoadingSubject.next(true);
        return this._http.get("" + url_1.Urls.getBaseUrlApi() + url, this.getRequestOptions())
            .map(function (response) { return response; })
            .catch(function (error) { return Observable_1.Observable.throw(error); })
            .finally(function () {
            _this.isLoadingSubject.next(false);
        });
    };
    HttpRequestBuilder.prototype.getRequestOptions = function () {
        var credentials = this.authenticationService.getCredentials();
        var headers = new http_1.Headers();
        headers.append('Authorization', credentials);
        var options = new http_1.RequestOptions({ headers: headers });
        return options;
    };
    HttpRequestBuilder.ctorParameters = function () { return [{ type: http_1.Http }, { type: authentication_service_1.AuthenticationService }]; };
    return HttpRequestBuilder;
}());
exports.HttpRequestBuilder = HttpRequestBuilder;
//# sourceMappingURL=http-request-builder.js.map


// WEBPACK FOOTER //
// http-request-builder.js